import { render } from '@wordpress/element';
import { createRoot as wpCreateRoot } from '@wordpress/element';
import GreenhouseAPIComponent from './react';

function mount(container: Element, node: JSX.Element): void {
  const maybeCreateRoot = wpCreateRoot as unknown as
    | ((c: Element | DocumentFragment) => { render: (n: JSX.Element) => void })
    | undefined;

  if (typeof maybeCreateRoot === 'function') {
    const root = maybeCreateRoot(container);
    root.render(node);
  } else {
    // React 17 pathway
    render(node, container as any);
  }
}

const greenhouseAPI = (): void => {
  const sections = document.querySelectorAll<HTMLElement>('[data-greenhouse]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const reactContainer = section.querySelector('[data-greenhouse-api]');
    if (!reactContainer) return;

    mount(reactContainer, <GreenhouseAPIComponent section={section} />);
  });
};

export default greenhouseAPI;
